import React from 'react';
import GalleryView, { GalleryItem } from '../../components/Creative/GalleryView';
// Sample data for cover designs
const coverGalleryItems: GalleryItem[] = [{
  id: '1',
  imageUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Fantasy Adventure Cover',
  creator: 'Elena Martinez',
  price: 199,
  priceType: 'fixed',
  serviceType: 'Full Cover Design',
  genre: ['Fantasy', 'Adventure'],
  description: 'Custom illustrated fantasy cover with detailed character work and magical elements.'
}, {
  id: '2',
  imageUrl: 'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Dark Mystery Cover',
  creator: 'James Wilson',
  price: 249,
  priceType: 'fixed',
  serviceType: 'Wraparound Cover',
  genre: ['Mystery', 'Thriller'],
  description: 'Atmospheric wraparound cover design with front, spine and back cover included.'
}, {
  id: '3',
  imageUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Romance Novel Cover',
  creator: 'Sophia Chen',
  price: 150,
  priceType: 'starting',
  serviceType: 'eBook Cover',
  genre: ['Romance', 'Contemporary'],
  description: 'Beautiful couple-focused cover design perfect for contemporary romance novels.'
}, {
  id: '4',
  imageUrl: 'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Sci-Fi Epic Cover',
  creator: 'Alex Thompson',
  price: 299,
  priceType: 'commissioned',
  serviceType: 'Full Cover Design',
  genre: ['Science Fiction', 'Space Opera'],
  description: 'Commissioned cover for a bestselling sci-fi series featuring custom digital artwork.'
}, {
  id: '5',
  imageUrl: 'https://images.unsplash.com/photo-1544947987-f6c4fa25fa4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Historical Fiction Cover',
  creator: 'Maria Garcia',
  price: 175,
  priceType: 'fixed',
  serviceType: 'eBook Cover',
  genre: ['Historical', 'Drama'],
  description: 'Period-appropriate design with attention to historical details and typography.'
}, {
  id: '6',
  imageUrl: 'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'YA Fantasy Cover',
  creator: 'Elena Martinez',
  price: 225,
  priceType: 'starting',
  serviceType: 'Full Cover Design',
  genre: ['Fantasy', 'Young Adult'],
  description: 'Eye-catching YA fantasy cover with modern design elements and vibrant colors.'
}, {
  id: '7',
  imageUrl: 'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Horror Novel Cover',
  creator: 'James Wilson',
  price: 180,
  priceType: 'fixed',
  serviceType: 'eBook Cover',
  genre: ['Horror', 'Supernatural'],
  description: 'Atmospheric and chilling design that sets the mood for horror stories.'
}, {
  id: '8',
  imageUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Literary Fiction Cover',
  creator: 'Sophia Chen',
  price: 95,
  priceType: 'starting',
  serviceType: 'Simple Cover',
  genre: ['Literary Fiction', 'Contemporary'],
  description: 'Minimalist design with typography focus for literary fiction titles.'
}];
const CoverGallery = () => {
  return <GalleryView items={coverGalleryItems} title="Cover Design Gallery" categoryName="Cover Designs" data-id="element-9283" data-mp="ut2610imaz7n" />;
};
export default CoverGallery;